module.exports = __webpack_public_path__ + "img/img3.b7f6f786.svg";